import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.813 11.397 5.998-8.085c.47-.632 1.349-.239 1.349.603v6.258c0 .505.344.913.77.913h2.917c.663 0 1.016.927.579 1.518l-5.999 8.084c-.469.632-1.348.239-1.348-.603v-6.258c0-.505-.345-.913-.77-.913H7.39c-.663 0-1.016-.927-.578-1.517"
    }, null, -1)
  ])))
}
export default { render: render }